/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStampsConfig} from '../api'

 export const useQueryGetStampsConfig = createReactQueryHook('getStampsConfig', getStampsConfig)
